export const PICKUP = 'PICKUP'
export const DELIVERY = 'DELIVERY'

// ITEM FULFILLMENT METHOD - Which fulfillment method was chosen for a cart/order item
export const ITEM_FULFILLMENT_METHOD = {
  PICKUP: PICKUP, // Item will be picked up
  DELIVERY: DELIVERY, // Item will be delivered
}
